import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReviewReportGoalFormModel} from '../../models/review.model';

@Component({
  selector: 'app-objective',
  templateUrl: './objective.component.html',
  styleUrls: ['./objective.component.scss'],
})
export class ObjectiveComponent implements OnInit {
    @Input() objective: ReviewReportGoalFormModel;
    @Input() show = false;
    @Output() onChange = new EventEmitter();

    duration_translation = {
        'short': '__REVIEW_REPORT_GOALS_AND_OBJECTIVES_SHORT_TERM__',
        'medium': '__REVIEW_REPORT_GOALS_AND_OBJECTIVES_MEDIUM_TERM__',
        'long': '__REVIEW_REPORT_GOALS_AND_OBJECTIVES_LONG_TERM__'
    }

    constructor() {
    }

    ngOnInit() {
    }

    changeStatus() {
        this.onChange.emit({status: !this.objective.status, id: this.objective.id});
    }
}
